"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8672],{

/***/ 95890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ images_grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
;// CONCATENATED MODULE: ./segments/desktop/grid/grid-service.js
var MOBILE_GRID_IMAGE_SIZE = 300;
var getImageSize = function(numberOfImages) {
    var isMobileOrTablet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isMobileOrTablet) return {
        width: MOBILE_GRID_IMAGE_SIZE,
        height: "auto"
    };
    switch(numberOfImages){
        case 1:
            return {
                width: 607,
                height: 346
            };
        case 2:
            return {
                width: 607,
                height: 346
            };
        case 3:
            return {
                width: 400,
                height: 346
            };
        case 4:
            return {
                width: 300,
                height: 300
            };
        default:
            return {
                width: 300,
                height: 300
            };
    }
};

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./utils/arrays.js
var arrays = __webpack_require__(84657);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/default-props.js

/* harmony default export */ var default_props = ({
    images: [],
    imagePosition: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
    isIcon: false
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/images-grid.scss.js




var MOBILE_GRID_IMAGE_SIZE_PX = "".concat(MOBILE_GRID_IMAGE_SIZE, "px");
var SM_PX = "".concat(vp_sizes.SM, "px");
var MAX_DESKTOP_GRID_WIDTH_PX = "".concat(vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px");
var ITEMS_MARGIN = 16;
var ITEMS_MARGIN_PX = "".concat(ITEMS_MARGIN, "px");
var StyledImagesGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euxwbea0"
})("display:flex;flex-wrap:wrap;justify-content:center;&.no-wrap{flex-wrap:nowrap;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){flex-wrap:wrap;}}.grid-image-container{display:flex;flex-direction:column;margin:", ITEMS_MARGIN_PX, ";padding:16px 0;width:var(--grid-width);&.dynamic-width{width:unset;flex:1 1 0;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){width:var(--grid-width);flex:unset;}}.full-paragraph-wrapper{flex:1;margin-top:16px;&.buttons-alignment{.button-wrapper{min-height:56px;align-items:end;margin-top:auto;}}.full-paragraph{height:100%;}}.grid-image-wrapper{&.with-shadow{", (0,constants.getComponentShadow)(), "}}}@media (min-width:", SM_PX, ") and (max-width:", MAX_DESKTOP_GRID_WIDTH_PX, "){.grid-image-container{width:calc(33vw - ", ITEMS_MARGIN * 2, "px) !important;.grid-image{width:100% !important;.image{width:100% !important;}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.grid-image-container{.grid-image-wrapper{.grid-image{.image{width:", MOBILE_GRID_IMAGE_SIZE_PX, ";height:auto;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/images-grid.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var ImagesGrid = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ImagesGrid, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ImagesGrid);
    function ImagesGrid() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ImagesGrid);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldAddEmptyContainer", function() {
            var _props = _this.props, images = _props.images, numberOfCardsInRow = _props.numberOfCardsInRow;
            return numberOfCardsInRow && numberOfCardsInRow >= images.length;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ImagesGrid, [
        {
            key: "renderImages",
            value: function renderImages() {
                var _props = this.props, images = _props.images, isWithParagraph = _props.isWithParagraph, imagePosition = _props.imagePosition, textAlign = _props.textAlign, disableFixedWidth = _props.disableFixedWidth, titleSize = _props.titleSize, textSize = _props.textSize, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, imageStyle = _props.imageStyle, isIcon = _props.isIcon, numberOfCardsInRow = _props.numberOfCardsInRow, fitHeightToImgHeight = _props.fitHeightToImgHeight, buttonTopMargin = _props.buttonTopMargin, alignButtons = _props.alignButtons;
                return images.map(function(image, index) {
                    var ref = getImageSize(numberOfCardsInRow || images.length, isMobileOrTabletBrowser), height = ref.height, width = ref.width;
                    var fullParagraph = image.fullParagraph, shadow = image.shadow, restImageProps = _object_without_properties(image, [
                        "fullParagraph",
                        "shadow"
                    ]);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("grid-image-container", {
                            "dynamic-width": disableFixedWidth
                        }),
                        style: {
                            "--grid-width": "".concat(width, "px")
                        },
                        children: [
                            (restImageProps === null || restImageProps === void 0 ? void 0 : restImageProps.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("grid-image-wrapper", shadow && "with-shadow"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, _object_spread_props(_object_spread({
                                    height: fitHeightToImgHeight || isIcon ? "auto" : height,
                                    width: width,
                                    imageStyle: imageStyle,
                                    imagePosition: imagePosition
                                }, restImageProps), {
                                    className: "image"
                                }))
                            }),
                            isWithParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("full-paragraph-wrapper", {
                                    "buttons-alignment": alignButtons
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread_props(_object_spread({}, fullParagraph), {
                                    textAlign: textAlign,
                                    titleSize: titleSize,
                                    textSize: textSize,
                                    buttonTopMargin: buttonTopMargin
                                }))
                            })
                        ]
                    }, index);
                });
            }
        },
        {
            key: "renderEmpty",
            value: function renderEmpty() {
                var _props = this.props, images = _props.images, numberOfCardsInRow = _props.numberOfCardsInRow, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser;
                var emptyPlaces = (0,arrays.gettArrayWithIncrementingNumbers)(numberOfCardsInRow - images.length);
                var width = getImageSize(numberOfCardsInRow || images.length, isMobileOrTabletBrowser).width;
                return emptyPlaces.map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-image-container",
                        style: {
                            width: width
                        }
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, imagesGap = _props.imagesGap, disableFixedWidth = _props.disableFixedWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledImagesGrid, {
                    className: classnames_default()("images-grid", {
                        "no-wrap": disableFixedWidth
                    }),
                    style: {
                        gap: imagesGap
                    },
                    children: [
                        this.renderImages(),
                        this.shouldAddEmptyContainer() && this.renderEmpty()
                    ]
                });
            }
        }
    ]);
    return ImagesGrid;
}(react.PureComponent);
/* harmony default export */ var images_grid = ((0,generic_config_context/* withGenericConfig */.P)(ImagesGrid));
ImagesGrid.defaultProps = default_props;


/***/ }),

/***/ 28672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OnlyImageGridComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/only-image-grid-component.scss.js


var StyledOnlyImageGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2dgr8q0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding:0;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){padding:8px;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid.js + 3 modules
var images_grid = __webpack_require__(95890);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/only-image-grid-component.js









var OnlyImageGridComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnlyImageGridComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnlyImageGridComponent);
    function OnlyImageGridComponent() {
        (0,_class_call_check/* default */.Z)(this, OnlyImageGridComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnlyImageGridComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, images = _props.images, imagePosition = _props.imagePosition;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOnlyImageGridComponent, {
                    className: "only-image-grid-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_grid/* default */.Z, {
                        images: images,
                        imagePosition: imagePosition
                    })
                });
            }
        }
    ]);
    return OnlyImageGridComponent;
}(react.PureComponent);

OnlyImageGridComponent.defaultProps = {
    images: [
        {
            src: "/static/img/segment-layout-default-images/grid/man-with-blue-shirt.png"
        },
        {
            src: "/static/img/segment-layout-default-images/grid/woman-with-sunglasses-and-orange-shirt.png"
        },
        {
            src: "/static/img/segment-layout-default-images/grid/man-with-hat-and-sunglasses.png"
        },
        {
            src: "/static/img/segment-layout-default-images/grid/woman-with-sunglasses-in-the-wind.png"
        }
    ],
    paddingTop: "56px",
    paddingBottom: "56px",
    imagePosition: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER
};


/***/ }),

/***/ 84657:
/***/ (function(module) {


var convertToArrayIfNeeded = function(obj) {
    return Array.isArray(obj) ? obj : [
        obj
    ];
};
// Finds an empty cell index in the given array
var findEmptyIndex = function(arr) {
    if (arr) {
        for(var i = 0; i < arr.length; i++){
            if (!arr[i]) {
                return i;
            }
        }
        return arr.length;
    }
    return -1;
};
// returns a random value from the given array
var getRandomValue = function(arr) {
    var randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
};
// moves the given values to the beginning of the array
var moveToBeginningIfExists = function(arr, valuesToBeAtBeginning) {
    if (arr && valuesToBeAtBeginning) {
        for(var i = valuesToBeAtBeginning.length - 1; i >= 0; i--){
            var value = valuesToBeAtBeginning[i];
            var index = arr.indexOf(value);
            if (index > -1) {
                arrayMove(arr, index, 0);
            }
        }
    }
    return arr;
};
var arrayMove = function(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
};
var gettArrayWithIncrementingNumbers = function(size) {
    return Array.from(Array(size).keys());
};
module.exports = {
    convertToArrayIfNeeded: convertToArrayIfNeeded,
    findEmptyIndex: findEmptyIndex,
    getRandomValue: getRandomValue,
    moveToBeginningIfExists: moveToBeginningIfExists,
    arrayMove: arrayMove,
    gettArrayWithIncrementingNumbers: gettArrayWithIncrementingNumbers
};


/***/ })

}]);